import type { DeliveryBundle, DeliveryEvent, DeliveryState } from './deliveryState'

export interface StagedResult {
  readonly state: DeliveryState
  readonly events: readonly DeliveryEvent[]
}

/**
 * Records a finished download: verified (`failure === ''`) it becomes the
 * pending bundle for the next launch; otherwise it is dropped with the first
 * failing check as the reason. A failed download is not a bad bundle — it is
 * offered again, up to `DOWNLOAD_FAILURE_LIMIT` times in a row. Port of
 * `delivery.Staged`.
 */
export function staged(
  input: DeliveryState,
  bundle: DeliveryBundle,
  failure: string,
): StagedResult {
  if (failure !== '') {
    const failedCount = input.failedManifest === bundle.manifest ? input.failedCount + 1 : 1
    return {
      state: { ...input, failedManifest: bundle.manifest, failedCount },
      events: [{ name: 'map_update_bundle_rejected', sequence: bundle.sequence, reason: failure }],
    }
  }
  const { failedManifest: _failed, ...rest } = input
  return {
    state: { ...rest, failedCount: 0, pending: bundle, onDisk: [...input.onDisk, bundle] },
    events: [{ name: 'map_update_download_completed', sequence: bundle.sequence }],
  }
}
